
import React from "react";
import { APP_VERSION, BUILD_DATE } from "@/config/version";
import { Badge } from "@/components/ui/badge";

interface VersionIndicatorProps {
  className?: string;
  showBuildDate?: boolean;
}

export const VersionIndicator = ({ 
  className, 
  showBuildDate = false 
}: VersionIndicatorProps) => {
  return (
    <div className={className}>
      <Badge variant="outline" className="text-xs">
        v{APP_VERSION}
      </Badge>
      {showBuildDate && (
        <span className="text-xs text-muted-foreground ml-2">
          Built: {new Date(BUILD_DATE).toLocaleDateString()}
        </span>
      )}
    </div>
  );
};
